// modules
import { addModal } from 'weblite-web-modal-viewer'
import { ShareWappModal } from './share-wapp-modal'

const COMPONENT_ID = 'shareWappModal'

export const showShareWappModal = (
  props: Parameters<typeof ShareWappModal>[0],
) => addModal({ id: COMPONENT_ID, props })

export default {
  [COMPONENT_ID]: {
    Component: ShareWappModal,
  },
}
